import { RootState } from '@/store/main';

export const selectRegistrants = (state: RootState) => state.registrants.registrants;
export const selectRegistrantsCount = (state: RootState) => state.registrants.registrantsCount;
export const selectRegistrantsLoading = (state: RootState) => state.registrants.loadingRegistrants;
export const selectProjectCourse = (state: RootState) => state.registrants.course;
